import { render, staticRenderFns } from "./PreviewNewImage.vue?vue&type=template&id=4d800388&scoped=true&"
import script from "./PreviewNewImage.vue?vue&type=script&lang=js&"
export * from "./PreviewNewImage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewNewImage.vue?vue&type=style&index=0&id=4d800388&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d800388",
  null
  
)

export default component.exports